import { css } from "@compiled/react";

import { ConfluenceOverlayTemplate } from "@/components/signup/layouts";
import SiteActivation, {
    JoinableSites
} from "@/components/signup/site-activation";

import {
    JoinableSitesSubheading,
    WelcomeBackHeading
} from "../../../components";

export const CurrentProductJoinableUser = () => (
    <ConfluenceOverlayTemplate size="sm">
        <div css={containerCss}>
            <WelcomeBackHeading />
            <JoinableSitesSubheading />
            <SiteActivation
                CurrentProductJoinableUser={<JoinableSites />}
                useContactExpandCohortLogic={true}
            />
        </div>
    </ConfluenceOverlayTemplate>
);

const containerCss = css({
    display: "grid",
    gap: "10px"
});
